// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, Fragment} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './step_cards.module.less';
import cn from 'classnames';
import {Button} from '../../../../hola/pub/lib/button';
import Icon_arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import {perr} from 'hola_pub_util';
import anim_styles from '../animation.module.less';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';

const step_cards = [
    {
        id: 'cp',
        step: 1,
        title: 'Choose type of proxy you need',
        img: 'step1',
    },
    {
        id: 'cc',
        step: 2,
        title: 'Choose country',
        img: 'step2',
    },
    {
        id: 'gp',
        step: 3,
        title: '🎉 Get your free proxy, it has been configured successfully!🐣',
        img: 'step3',
    },
];

const Step_card = (props: typeof step_cards[0])=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const {id, step, title, img} = props;
    return <div className={styles.step_wrapper}>
      <div className={cn(styles.step_number, theme.P, theme.p24, styles[id])}>
        {step}</div>
      <div className={styles.card_wrapper}>
        <div className={cn(styles.step_card, styles[id])}>
          <p className={cn(theme.mono16)}><T>{title}</T></p>
          <div className={styles.step_card_img}>
            <img className={cn(styles[id])}
              src={toolip_img_url(`toolip/${img}.svg`)}/>
          </div>
        </div>
      </div>
    </div>;
};

export const Step_cards = ()=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    return <section className={styles.step_cards} id={'hp_products'}>
      <div className={styles.bg}/>
      <div className={styles.wrapper}>
        <h2><T>Get started effortlessly</T></h2>
        <div className={cn(theme.container, styles.container)}>
          {step_cards.map(c=>{
            return <Step_card key={c.id} {...c}/>;
          })}
        </div>
        <div>
          <Button caption={<Fragment><T>Start your free trail</T>
            <Icon_arrow_right/></Fragment>} size={'lg'} no_jump
            to={'/dashboard'} fit
            round={false}
            on_click={()=>{
              perr({id: 'toolip_homepage_get_started_top_click'});
            }} cls={cn(styles.hero_cta, anim_styles.hero_showup_3)}
            />
        </div>
      </div>
    </section>;
};
